import Vue from 'vue'
import Router from 'vue-router'
import HelloWorld from '@/components/HelloWorld'
import About from '@/components/about'
import Product from '@/components/product'
import ProductInfo from '@/components/productInfo'
import Tech from '@/components/tech'
import Market from '@/components/mark'
import Support from '@/components/support'
import Login from '@/components/login'
import NEWS from '@/components/newsInfo'
import ProSearch from '@/components/proSearch'


Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Login',
      component: () => import('@/components/login')
    },
    {
      path: '/about',
      name: 'About',
      component: About
    },
    {
      path: '/product',
      name: 'Product',
      component: Product
    },
    {
      path: '/productInfo',
      name: 'ProductInfo',
      component: ProductInfo
    },
    {
      path: '/tech',
      name: 'Tech',
      component: Tech
    },
    {
      path: '/market',
      name: 'Market',
      component: Market
    },
    {
      path: '/support',
      name: 'Support',
      component: Support
    },
    {
      path: '/home',
      name: 'Home',
      component: HelloWorld
    },
    {
      path: '/news',
      name: 'News',
      component: NEWS
    },
    {
      path: '/proSearch',
      name: 'proSearch',
      component: ProSearch
    }
  ],
  scrollBehavior(to, from,savedPosition) {
    return {
      x: 0,
      y: 0
    }
  }
})



// WEBPACK FOOTER //
// ./src/router/index.js